import React from "react";
import Icon from "./Icon";
export default function BookOpen(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 2.75H7.33337C8.30583 2.75 9.23847 3.13631 9.9261 3.82394C10.6137 4.51158 11 5.44421 11 6.41667V19.25C11 18.5207 10.7103 17.8212 10.1946 17.3055C9.67886 16.7897 8.97939 16.5 8.25004 16.5H1.83337V2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 2.75H14.6667C13.6942 2.75 12.7616 3.13631 12.0739 3.82394C11.3863 4.51158 11 5.44421 11 6.41667V19.25C11 18.5207 11.2897 17.8212 11.8055 17.3055C12.3212 16.7897 13.0207 16.5 13.75 16.5H20.1667V2.75Z"
  }));
}
BookOpen.displayname = "BookOpen";
//# sourceMappingURL=BookOpen.js.map